import { render, staticRenderFns } from "./BAList.vue?vue&type=template&id=17357b0f&scoped=true&"
import script from "./BAList.vue?vue&type=script&lang=js&"
export * from "./BAList.vue?vue&type=script&lang=js&"
import style0 from "./BAList.vue?vue&type=style&index=0&id=17357b0f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17357b0f",
  null
  
)

export default component.exports